import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { RoomInfoStyled } from "./styled";
import { RENDER_ROOM_TYPE , RENDER_BOOKING_SOURCE} from "utils/functions/musicHall";
import moment from "moment";

const RoomInfo = ({
  theme_standard,
  booker_first_name,
  booking_date,
  booking_source,
  event_start_time,
  event_end_time,
  setup_cleanup_start_time,
  setup_cleanup_end_time,
  room_type,
  room_name_th,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <RoomInfoStyled className={customClass}>
      {/* ชื่อที่ใช้ลงนัดใน Outlook = ชื่อผู้จอง (Firstname ใน Customer Detail) */}
      <div className="room_info_row">
        <div className="room_info_head">Name (Outlook)</div>
        <div className="room_info_detail">{booker_first_name || "-"}</div>
      </div>
      <div className="room_info_row">
        <div className="room_info_head">Room</div>
        <div className="room_info_detail">
          {RENDER_ROOM_TYPE(room_type).labelTh}
        </div>
      </div>
      {room_type === "2" && room_name_th && (
        <div className="room_info_row">
          <div className="room_info_head">Room Name</div>
          <div className="room_info_detail">{room_name_th}</div>
        </div>
      )}
      <div className="room_info_row">
        <div className="room_info_head">Type</div>
        <div className="room_info_detail">{RENDER_BOOKING_SOURCE(booking_source).labelEn}</div>
      </div>
      <div className="room_info_row">
        <div className="room_info_head">Event Date</div>
        <div className="room_info_detail">
          {moment(booking_date).format("DD/MM/YYYY")}
        </div>
      </div>
      {/* เวลาเตรียม/เก็บงานมีเฉพาะ Music Hall (ห้องซ้อมเก็บเป็น "00.00") */}
      {room_type === "1" && (
        <div className="room_info_row">
          <div className="room_info_head">Set-up & Clean-out Time</div>
          <div className="room_info_detail">
            {setup_cleanup_start_time && setup_cleanup_end_time
              ? `${setup_cleanup_start_time} - ${setup_cleanup_end_time}`
              : "-"}
          </div>
        </div>
      )}
      <div className="room_info_row">
        <div className="room_info_head">Time</div>
        <div className="room_info_detail">
          {event_start_time} - {event_end_time}
        </div>
      </div>
      <div className="room_info_row">
        <div className="room_info_head">Terms & Conditions Agreement</div>
        <div className="room_info_detail">YES</div>
      </div>
    </RoomInfoStyled>
  );
};

RoomInfo.propTypes = {};

export default RoomInfo;
